module.exports = __webpack_public_path__ + "img/zongshumei_p.5765073e.png";